/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { loadFromLocalStorage } from '../common/localStorage';
import { UserRole, Module, RoleModuleMapping } from '../common/UserModel';
import { fetchModulesEndPoint } from '../common/constants';
import { asApplicationJsonBody } from '../common/graphqlJsonBody';

const initialState = {
    selectedRole: null,
    isLoading: false
};
const saveSelectedRoleRequest = 'SAVE_CURRENT_ROLE';
const getRoleRequest = 'GET_ROLEMODULE_REQUEST'
const getRoleResponse = 'GET_ROLEMODULE_RESPONSE'

export const actionCreators = {

    saveSelectedRoleRequest: (selectedRole: UserRole) => async (dispatch: any) => {
        dispatch({ type: saveSelectedRoleRequest, selectedRole });
        return;
    },
    getRole: (roleid: number) => async (dispatch: any) => {
        dispatch({ type: getRoleRequest });
        const token: string = loadFromLocalStorage('AuthToken');
        const encodedToken = 'Bearer ' + token;
        const headerDict: any = {
            'Authorization': encodedToken,
            'Content-Type': 'application/json'
        };
        const queryString = `query{
	allroles (roleid:${roleid})
	{
		data{
			rolename
			roleid
			rolemodulemapping{
				module{
				modulename
				id
				}
			}
		}
	}
}`

        try {
            if (navigator.onLine) {
                const response = await fetch(fetchModulesEndPoint, {
                    headers: new Headers(headerDict),
                    body: asApplicationJsonBody(queryString),
                    method: 'POST'
                });
                const responseData = await response.json();
                const role: any = responseData.data.allroles.count != 0 ? responseData.data.allroles.data[0] : null;
                dispatch({ type: getRoleResponse, role });
            }
        }
        catch (e) {

        }
    }
}
export const reducer = (state: any, action: any) => {
    state = state || initialState;
    switch (action.type) {
        case saveSelectedRoleRequest:
            return {
                ...state,
                selectedRole: action.selectedRole,
                isLoading: false
            };
        case getRoleRequest:
            return {
                ...state,
                isLoading: true
            };
        case getRoleResponse:
            if (action.role != null) {
                const modules = '';
                const moduleList: Array<Module> = [];
                action.role.rolemodulemapping.map((rolemodulemapping: RoleModuleMapping) => {
                    moduleList.push({ id: rolemodulemapping.module.id, modulename: rolemodulemapping.module.modulename });
                });
                const selectedRole = {
                    id: action.role.roleid,
                    userrole: action.role.rolename,
                    modules: action.role.rolemodulemapping.reduce((a: any, rolemodulemapping: RoleModuleMapping) => {
                        return a + `,${rolemodulemapping.module.modulename}`;
                    }, modules).substr(1),
                    selectedModules: moduleList
                };
                return {
                    ...state,
                    isLoading: false,
                    selectedRole
                };
            }
            else {
                return {
                    ...state,
                    isLoading: false,
                    selectedRole: 'norole'
                };
            }
    }
    return state;
};
